module.exports = __webpack_public_path__ + "static/media/eye-show.57504c32.png";